
/* Replo's React runtime is intentionally dead on this page (it reverted copy to the source
   store). These carousels are therefore driven natively: scroll-snap + scrollBy. */
(function(){
  function wire(region){
    var track = region.querySelector('[data-replo-part="slide-track"]');
    if(!track) return false;
    var slides = [];
    for(var i=0;i<track.children.length;i++){
      var c = track.children[i];
      if(c.getAttribute && c.getAttribute('data-replo-part') === 'slide') slides.push(c);
    }
    if(slides.length < 2) return false;

    track.style.transform = 'none';          /* clear the frozen React offset */
    track.style.overflowX = 'auto';
    track.style.overflowY = 'hidden';
    track.style.scrollSnapType = 'x mandatory';
    track.style.scrollBehavior = 'smooth';
    track.setAttribute('data-native-carousel','');
    slides.forEach(function(s){
      s.style.scrollSnapAlign = 'start';
      s.style.flex = '0 0 100%';
    });

    function step(){
      if(slides.length > 1){
        var d = slides[1].offsetLeft - slides[0].offsetLeft;
        if(d > 1) return d;
      }
      return track.clientWidth || 1;
    }
    function index(){ return Math.round(track.scrollLeft / step()); }

    var btns = region.querySelectorAll('[data-replo-part="nav-button"]');
    var live = region.querySelector('[aria-live]');
    function sync(){
      var i = index(), last = slides.length - 1;
      for(var k=0;k<btns.length;k++){
        var b = btns[k], next = b.getAttribute('data-direction') === 'next';
        if(next ? i >= last : i <= 0) b.setAttribute('disabled','');
        else b.removeAttribute('disabled');
      }
      if(live) live.textContent = 'Slide ' + (i+1) + ' of ' + slides.length;
    }
    for(var k=0;k<btns.length;k++){
      (function(b){
        b.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          track.scrollBy({ left: (b.getAttribute('data-direction')==='next' ? 1 : -1) * step(),
                           behavior: 'smooth' });
        });
      })(btns[k]);
    }
    var t = null;
    track.addEventListener('scroll', function(){
      if(t) clearTimeout(t);
      t = setTimeout(sync, 90);
    }, { passive: true });
    sync();
    return true;
  }

  function boot(){
    var n = 0;
    var regions = document.querySelectorAll('[data-replo-carousel="true"]');
    for(var i=0;i<regions.length;i++){ if(wire(regions[i])) n++; }
    /* a track whose arrows live outside the labelled region still gets snap+swipe */
    var tracks = document.querySelectorAll('[data-replo-part="slide-track"]:not([data-native-carousel])');
    for(var j=0;j<tracks.length;j++){
      var host = tracks[j].closest('[data-replo-carousel="true"]') || tracks[j].parentElement;
      if(host && wire(host)) n++;
    }
    window.__carouselsWired = n;
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
